import { render } from "./NFTsList.vue?vue&type=template&id=b47cb96a&scoped=true"
import script from "./NFTsList.vue?vue&type=script&lang=js"
export * from "./NFTsList.vue?vue&type=script&lang=js"

import "./NFTsList.vue?vue&type=style&index=0&id=b47cb96a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b47cb96a"]])

export default __exports__